import React, { useEffect } from 'react';
import { Hero } from '../components/landing/Hero';
import { ProblemSection } from '../components/landing/ProblemSection';
import { SolutionSection } from '../components/landing/SolutionSection';
import { HowItWorks } from '../components/landing/HowItWorks';
import { GamificationSection } from '../components/landing/GamificationSection';
import { RetentionSection } from '../components/landing/RetentionSection';
import { WhiteLabelSection } from '../components/landing/WhiteLabelSection';
import { FinalCTA } from '../components/landing/FinalCTA';
import { Footer } from '../components/landing/Footer';
import { Dumbbell } from 'lucide-react';
export function LandingPage() {
  useEffect(() => {
    document.title = 'Iron Gym - Plataforma de Retenção Inteligente para Academias';
  }, []);
  return <div className="min-h-screen bg-white flex flex-col" data-id="element-211">
      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-md border-b border-gray-100" data-id="element-212">
        <div className="container mx-auto px-4 h-16 flex items-center justify-between max-w-7xl" data-id="element-213">
          <div className="flex items-center gap-2" data-id="element-214">
            <div className="bg-[#FF6B35] p-1.5 rounded-lg" data-id="element-215">
              <Dumbbell className="h-5 w-5 text-white" data-id="element-216" />
            </div>
            <span className="text-xl font-bold text-[#2D3748] tracking-tight" data-id="element-217">
              Iron Gym
            </span>
          </div>

          <a href="https://irongym.malbs.com.br/" target="_blank" rel="noopener noreferrer" className="text-sm font-semibold text-[#FF6B35] hover:text-[#e55a2b] transition-colors" data-id="element-218">
            Acessar Sistema
          </a>
        </div>
      </nav>

      <main className="flex-grow" data-id="element-219">
        <Hero data-id="element-220" />
        <ProblemSection data-id="element-221" />
        <SolutionSection data-id="element-222" />
        <HowItWorks data-id="element-223" />
        <GamificationSection data-id="element-224" />
        <RetentionSection data-id="element-225" />
        <WhiteLabelSection data-id="element-226" />
        <FinalCTA data-id="element-227" />
      </main>

      <Footer data-id="element-228" />
    </div>;
}